import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { initErrorLogger } from './lib/errorLogger';
import { initHeartbeat, attachGameEventSubscriptions } from './lib/heartbeat';
import './styles/globals.css';
import 'maplibre-gl/dist/maplibre-gl.css';

// Phase 15.3 — Logger MUSS vor dem React-Mount stehen, damit auch frühe
// Render-Errors abgefangen werden.
initErrorLogger();

// Phase 16 Hot-Fix — Tester-Tracking. Heartbeats laufen sobald ein Auth-Token
// vorhanden ist (sendHeartbeat checkt das selbst); ohne Token sind die Calls
// no-ops.
initHeartbeat();
attachGameEventSubscriptions();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
